"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnyTypeSchema = exports.EnumTypeSchema = exports.EnumMemberSchema = exports.PrimitiveTypeSchema = exports.DateTypeSchema = exports.BooleanTypeSchema = exports.FloatTypeSchema = exports.IntegerTypeSchema = exports.CurrencyTypeSchema = exports.StringTypeSchema = void 0;
const zod_1 = require("zod");
exports.StringTypeSchema = zod_1.z.literal('string');
exports.CurrencyTypeSchema = zod_1.z.literal('currency');
exports.IntegerTypeSchema = zod_1.z.literal('integer');
exports.FloatTypeSchema = zod_1.z.literal('float');
exports.BooleanTypeSchema = zod_1.z.literal('boolean');
exports.DateTypeSchema = zod_1.z.literal('date');
exports.PrimitiveTypeSchema = zod_1.z.union([
    exports.StringTypeSchema,
    exports.IntegerTypeSchema,
    exports.FloatTypeSchema,
    exports.BooleanTypeSchema,
    exports.CurrencyTypeSchema,
    exports.DateTypeSchema,
]);
exports.EnumMemberSchema = zod_1.z.object({
    value: zod_1.z.string(),
    display_name: zod_1.z.string().optional(),
    source: zod_1.z.array(zod_1.z.union([zod_1.z.string(), zod_1.z.number()])),
});
exports.EnumTypeSchema = zod_1.z.object({
    kind: zod_1.z.literal('enum'),
    members: zod_1.z.array(exports.EnumMemberSchema),
});
exports.AnyTypeSchema = zod_1.z.union([exports.PrimitiveTypeSchema, exports.EnumTypeSchema]);
//# sourceMappingURL=typeSchema.js.map